import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';

export default class LinePrice extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    
    componentDidMount() {

    }

    render() {
        return (
            <div className="linePrice">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >帮助中心</NavBar>
                <div className="contentBox">
                    <div className="title">关于起止区域价格</div>
                    <div className="first">
                        <div>1、乘客下单后，由司机提供上门接送服务。</div>
                        <div>2、上下车地址在接送范围内的免费，超过接送范围则按人数收取一定的接送服务费。</div>
                        <div>3、不同的起止区域接送范围及收费规则不同，具体以乘客提交订单时显示的溢价为准。</div>
                        <div>4、乘客实际支付价格 = 出发地溢价 + 出行位置票价 + 到达地溢价。</div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Member/HelpCenter/LinePrice/index.js